module.exports = __webpack_public_path__ + "static/qr_code_wa_chat_staging-e728d370b99e8c0da0140d5990d04573.png";